/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Approve_QuestionInputs */

const en_faq_approve_question = /** @type {(inputs: Faq_Approve_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can our team approve work before it goes out?`)
};

const lv_faq_approve_question = /** @type {(inputs: Faq_Approve_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai komanda var apstiprināt darbu pirms nosūtīšanas?`)
};

/**
* | output |
* | --- |
* | "Can our team approve work before it goes out?" |
*
* @param {Faq_Approve_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_approve_question = /** @type {((inputs?: Faq_Approve_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Approve_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_approve_question(inputs)
	return en_faq_approve_question(inputs)
});